module.exports = "<customer-page></customer-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appCustomer.html
// module id = 1261
// module chunks = 0